import {gql} from '@apollo/client';
import {noop} from '@benchling/js-utils';
import React, {useEffect} from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import ChemicalCounterpartLibrary from 'chemistry/ChemicalCounterpartLibrary';
import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {ErrorFragment} from 'graphql-client/Error';
import {TABLE_KEYS} from 'ui-library/scrollable/ScrollableTableConstants';

import {SolvateLibraryQuery} from './__generated/SolvateLibraryQuery';

export const SOLVATE_LIBRARY_QUERY = gql`
  query SolvateLibraryQuery @skipAudit @engComponent(name: CHEMISTRY) {
    solvates {
      id
      name
      code
      type
      molecularFormula
      calculatedMolecularWeight
      canonicalSmiles
      imageData {
        ... on SVGNode {
          base64Svg
        }
        ...Error
      }
    }
  }
  ${ErrorFragment.fragment}
`;

export default function SolvateLibrary(): JSX.Element {
  useEffect(() => {
    setWindowTitle('Solvates');
  }, []);

  const result = useBenchlingQuery<SolvateLibraryQuery>(SOLVATE_LIBRARY_QUERY);
  return (
    <ChemicalCounterpartLibrary
      title="Solvate library"
      addNewLabel="Add new solvate"
      items={result.type === QueryResultType.SUCCESS ? result.data.solvates : []}
      loading={result.type === QueryResultType.PENDING}
      tableKey={TABLE_KEYS.SOLVATE_LIBRARY_TABLE}
      searchPlaceholder="Solvate name or code"
      onAddNew={noop}
    />
  );
}
